import { render } from "./ActionsButton.vue?vue&type=template&id=ea2d0f7a"
import script from "./ActionsButton.vue?vue&type=script&lang=js"
export * from "./ActionsButton.vue?vue&type=script&lang=js"
script.render = render

export default script